import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DeviceStaticDataService } from '@shared/services/device-static-data.service';

@Pipe({
  name: 'getControl',
})
export class GetControlPipe implements PipeTransform {
  transform(form: UntypedFormGroup, controlName: string): UntypedFormControl {
    return form.controls[controlName] as UntypedFormControl;
  }
}
